new Swiper(".swiper-container.hero-carousel", {
  loop: true,
  speed: 700,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  effect: "slide",
  on: {
    init: function () {
      const bullets = document.querySelectorAll('.swiper-pagination-bullet');
      bullets.forEach((bullet, index) => {
        bullet.setAttribute('role', 'button');
        bullet.setAttribute('aria-label', `Go to slide ${index + 1}`);
        bullet.setAttribute('tabindex', '0');
      });
    }
  }
});

